<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">TBM Point</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>/
      <b>Loyalty Point System</b> /
      <b>TBM Points</b> /
      <b>Details</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Active -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title">Details</h4>
            <hr>

            <div class="row">
              <div class="col-6" style="text-align: center">
                <label style="font-weight: bold;">Earn Rate:</label>
                <div class="row">
                  <div class="col-2" style="text-align: center">
                    <label class="mb-3">BND: </label>
                    <br/>
                    <label>1</label>
                  </div>
                  <div class="col-2" style="text-align: center">
                    <br/>
                    <br/>
                    <label class="mb-1">: </label>
                  </div>
                  <div class="col-8" style="text-align: center">
                    <label>TBM Point: </label>
                    <input type="text" class="form-control" v-model="rate.earn_rate" />
                  </div>
                </div>
              </div>
              <div class="col-6" style="text-align: center">
                <label style="font-weight: bold;">Redeem Rate:</label>
                <div class="row">
                  <div class="col-2" style="text-align: center">
                    <label class="mb-3">BND: </label>
                    <br/>
                    <label>1</label>
                  </div>
                  <div class="col-2" style="text-align: center">
                    <br/>
                    <br/>
                    <label class="mb-1">: </label>
                  </div>
                  <div class="col-8" style="text-align: center">
                    <label>TBM Point: </label>
                    <input type="text" class="form-control" v-model="rate.spend_rate" />
                  </div>
                </div>
              </div>
            </div>

            <div class="row" style="margin-top: 30px;">
              <div class="col-12 text-center">
                <button class="btn btn-rounded btn-primary col-3" @click="update()">Save</button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>


<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "survey-add",

  data() {
    return {
      rate: []
    };
  },

  methods: {
    loadRate() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(axios.lpsURL + "/rate", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.rate = res.data;
          })
      }
    },

    update(){
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        swal({
          icon: 'warning',
          text: 'Are you sure?',
          buttons: ['Cancel', 'Yes']
        }).then((confirm) => {
          if(!confirm) {
            return;
          }
          axios.post(axios.lpsURL + "/rate/update",
            {
              earn_rate: this.rate.earn_rate,
              spend_rate: this.rate.spend_rate
            },
            {
              headers: {
                Authorization: "Bearer " + token
              }
            })
            .then(res => {
              if(res.data.success){
                swal({
                  icon: "success",
                  title: "Success",
                  text: res.data.message
                })
                .then(() => {
                  this.$router.push("/setting/point")
                })
              } else{
                swal({
                  icon: "error",
                  title: "Fail",
                  text: res.data.message
                })
              }
            })
        })
      }
    }
  },


  mounted() {
    this.loadRate()
  }
};
</script>
